
import NRITinDetails from './NRITinDetails'
import Notify from './Notify'
import { RouteComponentProps, Router } from '@gatsbyjs/reach-router'
import SuccessPage from './SuccessPage'

export default function NRITinValidationRoutes(_props: RouteComponentProps) {
    return (
        <Router style={{ display: "flex", height: "100%" }}>
            <NRITinDetails path="/" default />
            <Notify path="/notify" />
            <SuccessPage path="/successPage" />
        </Router>
    )
}
